<template>
    <main>
        <h1 class="mb-8">Cari: <strong>"{{ this.searchVal }}"</strong></h1>

        <!-- Campaign -->
        <h3 class="mb-6">Campaign</h3>
        <div class="mb-6">
            <campaign-data :data="campaign"></campaign-data>
            <div v-if="campaign.length < 1" class="text-center">
                <h3 class="text-center"><strong>Data tidak ditemukan.</strong></h3>
            </div>
        </div>
        <!-- / -->
        <!-- Sahabat ZX -->
        <h3 class="mb-6">Sahabat ZX</h3>
        <div class="mb-6">
            <sahabat-zx-data :mitra="mitra" :totalPagination="totalPagination" />
        </div>
        <!-- / -->
            
    </main>
</template>
<script>
    import SahabatZxData from '@/views/home/sahabat-zx/components/SahabatZXData.vue'
    export default {
        data: () => ({
            totalPagination: 0,
            mitra: [],
            searchVal: null,
            params: {
                status: 1
            },
            sahabatParams: {
                length: 12,
                start: 0,
                status: 1
            },
            campaign: []
        }),
        components: {
            CampaignData: () => import('@/views/home/campaign/components/CampaignData.vue'),
            SahabatZxData
        },
        methods: {
            searchCampaign() {
                this.params.search = this.searchVal
                this.$vs.loading()
                this.$store.dispatch('campaign/getData', {
                    mutation: 'SET_SEARCH_CAMPAIGN',
                    params: this.params
                })
                .then(campaign => {
                    this.$vs.loading.close()
                    this.campaign = campaign
                })
                .catch(e => {
                    this.$vs.loading.close()
                    this.showError(e)
                    return false
                })
            },
            searchSahabatZx() {
                this.sahabatParams.name = this.searchVal
                this.$vs.loading()
                this.$store.dispatch('mitra/getChoiceMitra', this.sahabatParams)
                .then(data => {
                    const mitra = data.data.slice()
                    this.mitra = mitra
                    this.totalPagination = Math.ceil( parseInt(data.recordsTotal) / this.sahabatParams.length )
                })
                .catch(e => {
                    console.error(e)
                    this.$vs.loading.close()
                    this.showError(e)

                    return false
                })
            }
        },
        watch: {
            $route: {
                handler(val) {
                    if(val.query.q) {
                        this.searchVal = val.query.q
                        this.params.search = this.searchVal
                        this.sahabatParams.name = this.searchVal
                        this.searchCampaign()
                        this.searchSahabatZx()
                    }
                },
                deep: true
            }
        },
        mounted() {
            this.searchVal = this.$route.query.q
            this.searchCampaign()
            this.searchSahabatZx()
        },
        created() {
            if(!this.$route.query.q) {
                this.$router.push(`/home`)
            }
        }
    }
</script>